<template>
  <div>
    <div id="data-upload-control" class="clearfix">
      <div class="btn btn-sm btn-outline-primary float-right position-relative">
        <vue-file @change="importUploadInfo" type="Object" class="file position-absolute w-100 h-100"></vue-file>
        <i class="fa fa-folder-open-o" aria-hidden="true"></i>
        导入
      </div>
    </div>

		<nav class="nav nav-tabs justify-content-end">
      <a class="nav-item nav-link" :class="{active: view === 'metadata'}" href="javascript:;" @click="changeView('metadata')">格式视图</a>
			<a class="nav-item nav-link" :class="{active: view === 'connection'}" href="javascript:;" @click="changeView('connection')">连接视图</a>
		</nav>
		<div class="tab-content" id="nav-tabContent">
      <div class="row">
        <div class="col-sm-5">
          <div class="card">
            <div class="card-header">
              {{ view === 'metadata' ? '设备树' : '设置' }}
            </div>
            <div class="card-body">
              <upload-data-tree v-if="view === 'metadata'"></upload-data-tree>
              <connection-tree v-if="view === 'connection'"></connection-tree>
            </div>
          </div>
        </div>

        <div class="col-sm-7">
          <div class="card">
            <div class="card-header">
              参数配置
            </div>
            <div class="card-body">
              <global-forms id="forms"></global-forms>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueFile from '@/components/utils/vue-file'
  import UploadDataTree from '@/components/home/trees/uploaddata-tree'
  import ConnectionTree from '@/components/home/trees/connection-tree'
  import Forms from '@/components/home/forms'
  import db from '@/extensions/db'

  export default {
    data () {
      return {
        view: 'metadata' // 'metadata' or 'connection'
      }
    },
    components: {
      'global-forms': Forms,
      UploadDataTree,
      ConnectionTree,
      VueFile
    },
    methods: {
      async importUploadInfo (name, data) {
        await this.importMetadata(data)
        await this.importConnection(data)

        this.$emitter.emit('updateForm', '')
      },
      async importMetadata (data) {
        await db.loadMetadata(data)
      },
      async importConnection (data) {
        await db.loadConnection(data)
      },
      changeView (view) {
        if (this.view !== view) {
          this.view = view
          this.$emitter.emit('updateForm', '')
        }
      }
    }
  }
</script>

<style scoped>
  #data-upload-control {
    margin-bottom: 1rem;
  }

  #data-upload-control > .btn {
    margin-left: 0.5rem;
  }

  #data-upload-control .file {
    top: 0;
    left: 0;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/tabs/data-upload.vue